module.exports = __webpack_public_path__ + "static/media/future-me.690ff2ce.mp3";